module.exports = __webpack_public_path__ + "static/media/csrddc_img1.16d91c12.svg";